/** 火车票分包业务文案 — 中文 */
export default {
  train: {
    nav: {
      home: '火车票',
      list: '选择车次',
      detail: '车次详情',
      orderFill: '填写订单',
      orderDetail: '订单详情',
      change: '火车票改签',
      changeOrderDetail: '改签订单详情',
      refundApply: '申请退票',
      refundProgress: '退款进度',
      stationFrom: '出发',
      stationTo: '到达',
      passengerAdd: '新增乘客',
      passengerEdit: '编辑乘客',
      routeTitle: '{from} → {to}',
    },
    common: {
      copy: '复制',
      cancel: '取消',
      confirm: '确定',
      reset: '重置',
      clear: '清空',
      book: '预订',
      payNow: '立即支付',
      submitOrder: '提交订单',
      detail: '详情',
      fromStation: '出发站',
      toStation: '到达站',
      departure: '出发',
      arrival: '到达',
      departureDate: '出发日期',
      searchTickets: '查询车票',
      highSpeedOnly: '高铁动车',
      customerService: '联系客服',
      actualPaid: '实付',
      subtotal: '小计',
      total: '合计',
      serviceFee: '服务费',
      copySuccess: '复制成功',
      unionOrderBadge: '联合订单',
      loading: '加载中',
      orderNo: '订单号：{id}',
      ticketNo: '取票号：{id}',
      ticketPrice: '票价',
      totalAmount: '订单总额',
      grandTotal: '共计',
      transfer: '经停',
      checkGate: '检票口：',
      expandAllPassengers: '展开查看全部乘客 ({count}人)',
      acceptStanding: '接受无座',
      reorder: '再次预订',
      buyReturn: '购买返程',
      changeTicket: '改签',
      refundTicket: '退票',
      cancelOrder: '取消订单',
      refundProgressLink: '查看退款进度 >',
      hasRefund: '有退款',
      remaining: '剩余{time}',
      selectAll: '全选',
      deselectAll: '取消全选',
      addEditPassenger: '添加/编辑乘客',
      onlineSeatSelect: '在线选座',
      refundChangeRules: '退改说明',
      warmReminder: '温馨提醒',
      serviceAgreement: '服务协议',
      agreeAllAgreements: '已阅读并同意以上所有服务协议',
      pleaseCheckAgreement: '请勾选协议后才能提交订单',
      bookNow: '立即订票',
      submitChange: '提交改签{count}人',
      coupon: '优惠券',
      noCouponAvailable: '暂无可用优惠券',
      couponSelected: '已选优惠券 -￥{amount}',
      noThreshold: '无门槛',
      couponDiscount: '满{min}减{price}',
      couponInstantOff: '立减{price}元',
      couponPercent: '满{min}享{price}折',
      originalTicket: '原车票',
      changeTicketTag: '改签票 {index}',
      changeOrderTag: '改签订单 {index}',
      changedOrRefunded: '已改签/已退票',
      verifying: '校验中...',
      lowest: '最低',
      dayDiff: '+{days}',
      dash: '—',
      unknownSeat: '未知座位',
      unknownStatus: '未知状态',
      invoice: '发票',
      noTrainInvoice: '暂无火车票发票',
      swipeHint: '左右滑动查看更多',
      shareRouteTitle: '{from}→{to}火车票',
      shareRouteTitleSpace: '{from}→{to} 火车票',
      shareDesc: '全场分期  0利息0手续费  40家银行信任支持的平台',
      shareBooking: '他正在0息游预定{from}-{to}的火车票',
      searchQuery: '火车票查询',
      domesticBooking: '国内火车票预订',
      hotelBundleTitle: '加订酒店，享最高12期免息分期',
      hotelBundleDesc: '火车票+酒店组合下单，更多优惠',
      goSelectHotel: '去选酒店',
      gotIt: '知道了',
      tip: '提示',
      confirmDelete: '确认删除',
      deletePassengerMsg: '确定要删除乘客"{name}"吗？',
      smsVerify: '请发送短信验证',
      continueOrder: '继续下单',
      continueChange: '继续改签',
      nonRefundableConfirm: '该票不可退款，是否继续{action}？',
      loadingOrder: '加载订单信息...',
      selectedCount: '已选择 {count} 人',
      changeBadge: '改签',
      notChangeable: '不可更改',
      selectDate: '请选择日期',
      tipTitle: '温馨提示',
      customerServicePhone: '联系客服：4007659936',
      peopleUnit: '{count}人',
      secondClass: '二等座',
      ticketType: {
        adult: '成人票',
        child: '儿童票',
        student: '学生票',
        disabledMilitary: '残疾军人票',
      },
      cardType: {
        idCard: '身份证',
        passport: '护照',
        hkMacao: '港澳通行证',
        twCompatriot: '台胞证',
      },
    },
    date: {
      today: '今天',
      tomorrow: '明天',
      dayAfter: '后天',
      weekdaySun: '周日',
      weekdayMon: '周一',
      weekdayTue: '周二',
      weekdayWed: '周三',
      weekdayThu: '周四',
      weekdayFri: '周五',
      weekdaySat: '周六',
      monthDay: '{month}月{day}日',
      monthDayTime: '{month}月{day}日 {time}',
      departTitle: '{date}{day}出发',
      departSuffix: '出发',
      pleaseSelect: '请选择日期',
      nightBadge: '夜间',
    },
    seat: {
      soldOut: '售罄',
      available: '有',
      tight: '紧张',
      none: '无',
      hasTicket: '有票',
      noTicket: '无票',
      lowestPrice: '最低',
      acceptStanding: '接受无座',
    },
    stop: {
      transfer: '经停',
      timetable: '时刻表',
      title: '时刻表',
      titleWithNo: '{trainNo} 时刻表',
      col: {
        station: '站名',
        arrive: '到达',
        depart: '发车',
        stay: '停留',
      },
      disclaimer: '具体以列车实际运行情况为准，请及时关注车站广播',
      loading: '加载时刻表信息...',
      loadingTimetable: '加载经停站信息...',
    },
    filter: {
      title: '筛选条件',
      advanced: '高级筛选',
      onlyAvailable: '仅看有票',
      highSpeed: '高铁动车',
      fuxing: '复兴号',
      quietCar: '静音车厢',
      quietCarOnly: '仅看静音车厢',
      seatType: '坐席类型',
      trainType: '车次类型',
      departTime: '出发时间',
      arriveTime: '到达时间',
      fromStation: '出发车站',
      toStation: '到达车站',
      recommend: '推荐筛选',
      departAt: '出发{time}',
      arriveAt: '到达{time}',
      departFrom: '出发{station}',
      arriveAtStation: '到达{station}',
      loadingTrains: '正在查询车次信息...',
      emptyTrains: '暂无车次信息',
      emptyTrainsTip: '请尝试修改搜索条件',
      trainTypeG: 'G 高速动车组',
      trainTypeD: 'D 动车组',
      trainTypeS: 'S 市郊旅客列车',
      trainTypeZ: 'Z 直达特快列车',
      trainTypeT: 'T 特快列车',
      trainTypeK: 'K 快速列车',
      trainTypeC: 'C 城际列车',
      trainTypeN: 'N 管内快速列车',
      trainTypeL: 'L 跨局临时旅客列车',
      trainTypeA: 'A 管局内临时旅客列车',
      trainTypeX: 'X 行包专列',
      trainTypeY: 'Y 旅游列车',
      trainTypeNormal: '普通列车',
      typeG: '高速动车组',
      typeD: '动车组',
      typeS: '市郊旅客列车',
      typeZ: '直达特快列车',
      typeT: '特快列车',
      typeK: '快速列车',
      typeC: '城际列车',
      typeN: '管内快速列车',
      typeL: '跨局临时旅客列车',
      typeA: '管局内临时旅客列车',
      typeX: '行包专列',
      typeY: '旅游列车',
    },
    sort: {
      earliestDepart: '出发最早',
      shortestDuration: '耗时最短',
      lowestPrice: '价格最低',
    },
    passenger: {
      typeTitle: '乘客类型',
      typeSection: '乘客类型',
      adult: '成人票',
      adultTicket: '成人票',
      child: '儿童票',
      childTicket: '儿童票',
      student: '学生票',
      disabledMilitary: '残疾军人票',
      name: '姓名',
      namePlaceholder: '请填写姓名',
      gender: '乘客性别',
      male: '男',
      female: '女',
      cardType: '证件类型',
      idType: '证件类型',
      cardNumber: '证件号码',
      idNumber: '证件号码',
      cardNumberPlaceholder: '请输入证件号码',
      idNumberPlaceholder: '请输入证件号码',
      saveEdit: '保存修改',
      confirmAdd: '确认添加',
      selectIdType: '请选择证件类型',
      idCardNi: '身份证',
      mobile: '手机号码',
      mobilePlaceholder: '请输入手机号码',
      tipsTitle: '根据铁路局规定：',
      tip1: '1.火车票购买只支持使用居民身份证，请确保身份证在有效期内',
      tip2: '2.请提供成年人真实有效的联系方式，对于未成年人等重点旅客者无法提供联系手机号的旅客，可提供监护人或亲属手机号码',
      tip3: '3.互联网售票实名制，请准确填写乘车人本人信息',
      childAloneWarning: '儿童不能单独乘车，至少需要一位成人陪同',
      childChangeAloneWarning: '儿童票不可单独改签，需与成人票一同办理',
      remainingChildWarning: '注意：剩余未改签乘客中有儿童但无成人陪同，请重新选择改签乘客',
      idTypeNI: '身份证',
      idTypePP: '护照',
      idTypeHR: '户口簿',
      idTypeJR: '军官证',
      idTypeHMP: '港澳通行证',
      idTypeTB: '台胞证',
      idTypeHX: '回乡证',
      idTypeBC: '出生证明',
      idTypeHK: '港澳居民居住证',
      idTypeHM: '港澳通行证',
      idTypeTW: '台湾通行证',
      idTypeFP: '外国人永久居留证',
    },
    service: {
      expertTitle: '火车出行专家',
      changeRefund: '退改无忧',
      quickTicket: '极速出票',
      support247: '7*24小时客服',
    },
    home: {
      title: '国内火车票预订',
      cardTitle: '国内火车票预订',
      defaultFrom: '北京',
      defaultTo: '上海',
      tabHome: '首页',
      tabOrders: '我的订单',
      highSpeedOnly: '高铁动车',
      searchBtn: '查询车票',
      serviceTitle: '火车出行专家',
      serviceRefund: '退改无忧',
      serviceFast: '极速出票',
      serviceSupport: '7*24小时客服',
      shareTitle: '火车票查询',
    },
    tab: {
      home: '首页',
      orders: '我的订单',
    },
    select: {
      loading: '正在加载城市数据...',
      loadingCities: '正在加载城市数据...',
      placeholder: '请输入城市或站点',
      searchPlaceholder: '请输入城市或站点',
      history: '历史选择',
      clear: '清空',
      hot: '热门推荐',
      hotRecommend: '热门推荐',
      chooseCity: '选择城市',
      selectCity: '选择城市',
      searching: '搜索中...',
      empty: '未找到相关站点',
      noResults: '未找到相关站点',
      emptyTip: '请尝试输入其他关键词',
      tryOtherKeyword: '请尝试输入其他关键词',
      city: '城市',
      station: '车站',
      badgeCity: '城市',
      badgeStation: '车站',
      historyCleared: '已清空历史记录',
    },
    refund: {
      selectPassengerSingle: '选择退票乘客（单选）',
      noticeTitle: '退票须知',
      noticeFeeTitle: '铁路局退票手续费：',
      noticeFee1: '1）开车前8天(含)以上：免费退票',
      noticeFee2: '2）开车前48小时以上：收取票价5%的退票费',
      noticeFee3: '3）开车前24-48小时：收取票价10%的退票费',
      noticeFee4: '4）开车前不足24小时：收取票价20%的退票费',
      noticeFee5: '5）开车前2小时后线上停止退票',
      noticeDescTitle: '说明：',
      noticeDesc1: '1）退票手续费由铁路局收取',
      noticeDesc2: '2）手续费不足2元按照2元收取',
      noticeDesc3: '3）距离开车7天及以内的车票，改签至8天及以上后退票收取5%的手续费',
      noticeDesc4: '4）下单成功手续费不予返还',
      noticeDesc5: '5）平台额外增加17元退票手续费(每人，不包含12306购票方式)',
      noticeDesc6: '6）退票约7个工作日内到账',
      feeDetailTitle: '退票费用明细',
      refundTicketAmount: '退还车票金额',
      feeDetailSection: '退票手续费明细：',
      fee12306: '• 12306收取退票费',
      feePlatform: '• 平台扣取服务费',
      feeSubtotal: '退票手续费小计',
      estimatedRefund: '预计退票金额',
      selectedPassenger: '已选择退票乘客',
      estimatedRefundShort: '预计退票',
      confirmRefund: '确认退票',
      popupFeeDetailTitle: '退票费用明细',
      popupRefundAmount: '1. 退还车票金额：',
      popupDeductFees: '2. 扣除相关费用：',
      popupServiceFeeDesc: '由于购票服务已完成，购票服务费',
      popupServiceFeeNoRefund: '不予退还。',
      popupRefundCostDesc: '本次退票操作收取12306退票费',
      popupPlatformFeeDesc: '平台需扣取服务费',
      popupSummary: '综上，您实际预计退回：',
      continueQuestion: '是否继续？',
      stillProceed: '仍要办理',
    },
    refundProgress: {
      refundAmount: '退款金额',
      platformServiceFee: '平台服务费',
      fee12306: '12306服务费',
      tip1: '• 退款将按照原支付方式原路返回',
      tip2: '• 退款到账时间受银行处理时间影响，一般为1-3个工作日',
      tip3: '• 如有疑问，请联系客服：4007659936',
      emptyTitle: '暂无退票进度信息',
      emptyDesc: '请稍后再查看或联系客服咨询',
      refresh: '刷新进度',
      backToOrder: '返回订单',
      statusCompleted: '退款成功',
      statusPending: '退款处理中',
      statusFailed: '退款失败',
      defaultDesc: '正在处理退款申请',
    },
    change: {
      originalOrder: '原订单信息',
      selectPassenger: '选择改签乘客',
      selectedCount: '已选择 {count} 人',
      childTip: '儿童票不可单独改签，需与成人票一同办理',
      remainingAdultTip: '注意：剩余未改签乘客中有儿童但无成人陪同，请重新选择改签乘客',
      noPassengerTitle: '暂无可改签乘客',
      noPassengerDesc: '当前订单中的乘客票务状态不支持改签操作',
      changeOptions: '改签选项',
      fromStation: '出发站',
      toStation: '到达站',
      departDate: '出发日期',
      dateRestrictionTip: '根据改签规则，您的订单只能改签至当日车次',
      stationRestrictionTip: '车票开车前48小时以内，不能变更到站',
      rulesTitle: '改签说明',
      rule1: '每张车票只能改签一次，改签后的车票不能再次改签，但可以退票；',
      rule2: '已取纸质车票或报销凭证，需至车站人工窗口办理改签；',
      rule3: '开车前48小时以上，可改签预售期内的其他列车；',
      rule4: '开车前48小时以内，可改签开车前的其他列车；',
      rule5: '开车后可改签当日24:00之前其他有余票的列车。',
      rule6: '已经办理开车后改签业务的车票，不能办理退票',
      searchTrains: '查询可改签车次',
      selectDepartDate: '选择出发日期',
    },
    changeOrderDetail: {
      countdownRemaining: '剩余{time}',
      countdownExpired: '已超时',
      countdownFormat: '{minutes}分{seconds}秒',
      changeOrderNo: '改签订单号：{no}',
      originalOrderNo: '原订单号：{no}',
      originalTrip: '原行程',
      changedTicket: '改签车票',
      passengerInfo: '乘客信息 ({count}人)',
      expandAllPassengers: '展开查看全部乘客 ({count}人)',
      stopStations: '经停 >',
      feeDetail: '费用明细',
      newTicketTotal: '改签票价总和',
      changeRefundAmount: '改签成功退还金额',
      oldTicketTotal: '旧票价总和',
      oldTicketRefund: '旧票退还金额',
      serviceFee: '服务费',
      paidAmount: '已付金额',
      actualPaid: '实付金额',
      changeRules: '改签说明',
      changeRulesLink: '《退票/改签说明》',
      viewChangeRules: '点击查看改签说明',
      changeRulesItem: '改签规则说明',
      changeFeeItem: '改签费用说明',
      cancelChange: '取消改签',
      payNow: '立即支付',
      stopStationsTitle: '经停站信息',
      stopNotice: '具体以列车实际运行情况为准，请及时关注车站广播',
      loadingStops: '加载经停站信息...',
      stopHeaderName: '站名',
      stopHeaderArrive: '到达',
      stopHeaderDepart: '发车',
      stopHeaderStay: '停留',
      rulesPopupTitle: '改签/退票说明',
      rulesRefundFeeTitle: '退票手续费标准',
      rulesChangeTitle: '改签规则',
      rulesSpecialTitle: '特殊情况',
      rulesTipTitle: '温馨提示',
      guideRulesTitle: '改签规则说明',
      guideFeeTitle: '改签费用说明',
      guideHelpTitle: '帮助说明',
      guideSpecialTitle: '特别说明',
      guideBasicRules: '改签基本规则',
      guideTimeRules: '时间规定',
      guideFeeStandard: '改签费标准',
      guideOtherRules: '其他重要规定',
      guideFormulaTitle: '费用计算规则',
      guideFormulaText: '新票价 + 服务费 与 原票价 对比',
      guideFormulaNote: '根据对比结果确定支付和退款金额',
      guideNeedPay: '新票价+服务费 大于 原票价',
      guideNeedPayResult: '需要支付',
      guideNoPay: '新票价+服务费 小于 原票价',
      guideNoPayResult: '无需支付',
      guideFeeExplain: '费用说明',
      guideHelpNeed: '需要帮助？',
      guideHelpText: '如有其他疑问，我们的客服团队随时为您服务',
      guideHotline: '客服热线：4007659936',
      guideServiceHours: '服务时间：7×24小时',
      statusPaySoon: '请尽快完成支付',
      statusTicketing: '正在为您出票，请耐心等待',
      statusTicketSuccess: '出票成功，请按时凭有效身份证进站乘车',
      statusTicketFailed: '出票失败，请联系客服处理',
      statusCancelled: '订单已取消',
      statusPartialRefunding: '正在处理部分退票，请稍候',
      statusPartialRefunded: '部分退票成功，差额将原路退回',
      statusRefunding: '正在处理退票，请稍候',
      statusRefunded: '退票完成，票款将原路退回',
      statusChanged: '改签成功，请按时凭有效身份证进站乘车',
      statusChanging: '正在处理改签，请稍候',
      statusChangeCancelled: '改签订单已取消',
      statusChangeFailed: '改签失败，可重新申请',
      statusPartialRefundFailed: '部分退票失败，请联系客服处理',
      statusRefundFailed: '退票失败，请联系客服处理',
      statusDefault: '订单详情',
      progressTicketing: '正在出票',
      progressRefunding: '正在退票',
      progressChanging: '正在改签',
      progressDone: '已完成',
      ticketStatusPending: '待支付',
      ticketStatusProcessing: '出票中',
      ticketStatusIssued: '已出票',
      ticketStatusFailed: '出票失败',
      ticketStatusCancelled: '订单取消',
      ticketStatusRefunding: '退票中',
      ticketStatusRefunded: '已退票',
      ticketStatusChanging: '改签中',
      ticketStatusChanged: '已改签',
      ticketStatusChangeFailed: '改签失败',
      ticketStatusRefundFailed: '退票失败',
      confirmCancelTitle: '提示',
      confirmCancelMsg: '是否取消改签订单',
      confirmCallTitle: '联系客服',
      confirmCallMsg: '即将拨打客服电话：4007659936',
      guideSpecialFee: '改签时平台额外增加17元退票改签费（不包含12306购票方式）',
      guideSpecialSpring: '改签或变更到站后的车票乘车日期在春运期间的，再退票时按票面价格20%核收退票费',
      guideBasicRule1: '改签是旅客变更乘车日期、时间、车次、席位、席别和到站时需办理的签证手续',
      guideBasicRule2: '旅客可办理一次改签，在铁路运输企业有运输能力的前提下办理',
      guideBasicRule3: '办理变更到站的改签时，应在开车前48小时以上',
      guideTime48PlusTitle: '开车前48小时以上',
      guideTime48PlusDesc: '可免费改签预售期内的列车',
      guideTime48MinusTitle: '开车前不足48小时',
      guideTime48MinusDesc: '可免费改签车票载明的乘车日期以前的列车；改签之后的列车核收改签费',
      guideTimeAfterTitle: '开车后当日24时之前',
      guideTimeAfterDesc: '可免费改签当日其他列车；改签次日及以后列车核收改签费',
      guideFeeRule1: '开车前24小时以上、不足48小时，改签票面乘车日期之后的列车时，按改签前后低票价车票票面价格的5%计',
      guideFeeRule2: '开车前不足24小时，改签票面乘车日期之后的列车时，按改签前后低票价车票票面价格的15%计',
      guideFeeRule3: '开车后在当日24时之前，改签次日及以后列车时，按改签前后低票价车票票面价格的40%计',
      guideOtherRule1: '已打印报销凭证的和使用现金支付方式购买的车票，仅可在车站售票窗口办理改签，并须交回报销凭证',
      guideOtherRule2: '开车后改签的车票，不办理退票',
      guideOtherRule3: '改签费以5角为单位，尾数小于2.5角的舍去、2.5角（含）以上且小于7.5角的计为5角、7.5角（含）以上的进为1元',
      guideNoticeContent: '具体规定以中国铁路12306官方最新公告为准。未尽事宜详见《国铁集团铁路旅客运输规程》等有关规定和车站公告。',
      guidePayLabel: '支付：新票价 + 服务费',
      guideRefundLabel: '退还：原票价',
      guidePayZero: '支付：0元',
      guideRefundDiff: '退还：原票价 - (新票价 + 服务费)',
      guideFeeNoticeContent: '改签费用根据新旧票价差异计算，包含服务费。如新票价加服务费低于原票价，则无需支付且退还差额；如高于原票价，则需支付全额并退还原票价',
      badge48Plus: '48h+',
      badge48Minus: '48h内',
      badgeAfterDepart: '开车后',
      percentHighlight: '{percent}%',
      rulesPopupChangeBody: '特别说明：改签时平台额外增加17元退票改签费(每人，不包含12306购票方式)\n\n改签或变更到站后的车票乘车日期在春运期间的，再退票时按票面价格20%核收退票费。\n\n1. 改签基本规则\n改签是旅客变更乘车日期、时间、车次、席位、席别和到站时需办理的签证手续。旅客可办理一次改签，在铁路运输企业有运输能力的前提下，按下列规定办理：\n1）开车前48小时以上，可免费改签预售期内的列车。\n2）开车前不足48小时，可免费改签车票载明的乘车日期以前的列车。\n3）开车前不足48小时，可改签车票载明的乘车日期之后预售期内列车，核收改签费。\n4）开车后，在当日24时之前，可免费改签当日其他列车。\n5）开车后，在当日24时之前，可改签车票载明的乘车日期之后预售期内列车，核收改签费。\n6）办理变更到站的改签时，应在开车前48小时以上，原车票已托运行李的，还应办理行李变更或取消业务。\n\n办理变更到站的改签时，应在开车前48小时以上。\n\n2. 报销凭证相关规定\n已打印报销凭证的和使用现金支付方式购买的车票，仅可在车站售票窗口办理改签，并须交回报销凭证。\n\n3. 票价差额处理\n旅客办理改签时，改签后的车票票价高于原票价时，核收票价差额；改签后的车票票价低于原票价时，退还票价差额，核收票价差额的退票费。\n\n4. 开车后改签限制\n开车后改签的车票，不办理退票。\n\n5. 改签退差费用标准\n改签退差时，票价差额退票费核收标准：\n1）距票面乘车站开车前8天以上的不收退票费\n2）开车前48小时以上、不足8天的，按票面价格5%计\n3）开车前24小时以上、不足48小时的，按票面价格10%计\n4）开车前不足24小时的，按票面价格20%计\n\n6. 改签费标准\n1）距票面乘车站开车前48小时以上改签时，或开车前不足48小时改签票面乘车日期及以前的列车时，以及开车后在当日24时之前改签当日其他列车时，均不收改签费\n2）开车前24小时以上、不足48小时，改签票面乘车日期之后的列车时，按改签前后低票价车票票面价格的5%计\n3）开车前不足24小时，改签票面乘车日期之后的列车时，按改签前后低票价车票票面价格的15%计\n4）开车后在当日24时之前，改签次日及以后列车时，按改签前后低票价车票票面价格的40%计\n\n重要提示：\n1）距票面乘车站开车前不足8天的车票，改签至开车前8天以上的列车，又在距开车前8天以上退票的，核收5%的退票费\n2）退票费、改签费以5角为单位，尾数小于2.5角的舍去、2.5角（含）以上且小于7.5角的计为5角、7.5角（含）以上的进为1元\n3）退票费最低按2元计收，当车票票面价格不足2元时按票面价格计收\n\n7. 跨境车票特殊规定\n1）广深港高速铁路跨境车票（发站或到站为香港西九龙站车票）有特殊规定\n2）中老铁路国际列车车票（发站和到站分别是中国或老挝境内客运车站车票）有特殊规定\n\n8. 其他规定\n未尽事宜详见《国铁集团铁路旅客运输规程》等有关规定和车站公告。',
      rulesPopupSpecialBody: '1）因病、学生证过期等特殊原因，按相关规定办理\n2）列车停运、晚点2小时以上等，可免费退票\n3）退款到账时间：7个工作日内（以银行处理时间为准）\n4）具体规定以铁路部门最新公告为准',
      rulesPopupTipPrefix: '本信息根据中国铁路12306官方规定整理，如有变更请以官方最新公告为准。\n详细信息可访问：',
    },
    toast: {
      missingParams: '缺少必要参数',
      missingStationCode: '缺少车站编码信息，请重新获取车次详情',
      stopStationFailed: '获取经停站信息失败',
      queryStopStationFailed: '查询经停站信息失败',
      trainSoldOut: '该车次已售罄，请选择其他车次',
      tooCloseToDepart: '距离发车时间太近了，无法购票',
      verifyFailed: '校验失败，请稍后重试',
      searchParamsIncomplete: '搜索参数不完整',
      networkError: '网络异常，请稍后重试',
      searchFailed: '搜索失败，请稍后重试',
      seatNoTicket: '该座位类型暂无余票',
      selectSeatFirst: '请先选择座位类型',
      copyFailed: '复制失败',
      pleaseLogin: '请先登录',
      loginStatusFailed: '获取登录状态失败',
      loginStatusRetry: '获取登录状态失败，请重试',
      trainDetailFailed: '获取车次详情失败',
      trainDetailRetry: '获取车次详情失败，请重试',
      standingOn: '已开启接受无座，可提高购票成功率',
      standingOff: '已关闭接受无座',
      deleteSuccess: '删除成功',
      deleteFailed: '删除失败',
      passengerListFailed: '获取常旅列表失败',
      changeFeeFailed: '获取改签费用失败',
      seatDataFailed: '座位数据加载失败',
      seatMapFailed: '座位图加载失败',
      maxSeats: '最多只能选择{count}个座位',
      maxBerths: '最多只能选择{count}个铺位',
      agreementConfirmed: '已确认同意所有服务协议',
      couponFailed: '获取优惠券失败',
      couponSelected: '已选择优惠券，优惠￥{amount}',
      selectCouponFailed: '选择优惠券失败',
      couponCancelled: '已取消优惠券',
      selectPassenger: '请选择乘客信息',
      selectSeat: '请选择座位信息',
      checkAgreement: '请勾选服务协议后再提交订单',
      orderSubmitCancelled: '已取消订单提交',
      orderSubmitFailed: '订单提交失败，请稍后重试',
      orderSubmitSuccess: '订单提交成功',
      selectPassengerFirst: '请先选择乘客',
      changeSubmitPay: '改签提交成功，请前往支付',
      changeSuccess: '改签成功',
      changeSubmitFailed: '改签提交失败',
      cityListFailed: '获取城市列表失败，请稍后重试',
      loadCitiesFailed: '获取城市列表失败，请稍后重试',
      historyCleared: '已清空历史记录',
      searchStationFailed: '搜索失败，请稍后重试',
      enterName: '请输入乘客姓名',
      enterIdNumber: '请输入证件号码',
      enterMobile: '请输入手机号码',
      addSuccess: '添加成功',
      saveFailedRetry: '保存失败，请稍后重试',
      loadPassengerSuccess: '乘客信息加载成功',
      loadPassengerListFailed: '获取乘客列表失败',
      loadPassengerDetailFailed: '获取乘客详情失败',
      invalidIdCard: '请输入正确的身份证号码',
      autoChildTicket: '根据身份证信息，已自动设置为儿童票',
      nameRequired: '请输入乘客姓名',
      cardRequired: '请输入证件号码',
      mobileRequired: '请输入手机号码',
      invalidMobile: '请输入正确的手机号码',
      saveSuccess: '添加成功',
      editSuccess: '修改成功',
      saveFailed: '保存失败',
      saveRetry: '保存失败，请稍后重试',
      passengerLoaded: '乘客信息加载成功',
      passengerNotFound: '未找到乘客信息',
      passengerListLoadFailed: '获取乘客列表失败',
      passengerDetailFailed: '获取乘客详情失败',
      changeOrderNotFound: '改签订单号不存在',
      cancelSuccess: '取消成功',
      cancelChangeSuccess: '取消改签成功',
      cancelChangeFailed: '取消改签失败',
      cancelChangeRetry: '取消改签失败，请重试',
      noInvoiceData: '暂无发票数据',
      invoiceListFailed: '获取发票列表失败',
      orderDetailFailed: '获取订单详情失败',
      changeOrderDetailFailed: '获取改签订单详情失败',
      refundProgressFailed: '获取退款进度失败',
      missingOrderNo: '缺少订单号参数',
      refreshed: '已刷新',
      selectRefundPassenger: '请选择要退票的乘客',
      refundFeeQueryFailed: '查询手续费失败',
      ticketNonRefundable: '该票不可退款',
      refundFeeQuerying: '正在查询手续费，请稍等...',
      refundSubmitSuccess: '退票申请提交成功',
      refundSubmitFailed: '退票申请失败',
      noRefundablePassenger: '当前订单暂无可退票乘客',
      changeWithin48h: '车票开车前48小时以内，不能变更到站',
      selectAtLeastOne: '请至少选择一位乘客',
      childChangeNeedAdult: '儿童票不可单独改签，请选择至少一位成人乘客',
      remainingChildNoAdult: '剩余未改签乘客中有儿童但无成人陪同，请重新选择改签乘客',
      orderNoEmpty: '订单号不能为空',
      operationFailed: '操作失败',
      queryingFee: '查询手续费中...',
      queryFeeFailed: '查询手续费失败',
      notRefundable: '该票不可退款',
      queryingFeeWait: '正在查询手续费，请稍等...',
      applyingRefund: '申请退票中...',
      refundApplySuccess: '退票申请提交成功',
      refundApplyFailed: '退票申请失败',
      missingOrderId: '缺少订单号参数',
      selectOnePassenger: '请至少选择一位乘客',
      childNeedAdult: '儿童票不可单独改签，请选择至少一位成人乘客',
      remainingAdultIssue: '剩余未改签乘客中有儿童但无成人陪同，请重新选择改签乘客',
      stationChangeRestricted: '车票开车前48小时以内，不能变更到站',
      queryStopFailed: '查询经停站信息失败',
      changeDetailFailed: '获取改签订单详情失败',
    },
    btn: {
      refundHistory: '退订记录',
      applyRefund: '申请退票',
      confirmRefund: '确认退票',
      submitRefund: '提交退票',
      viewRefundProgress: '查看退款进度',
      applyChange: '申请改签',
      confirmChange: '确认改签',
      cancelChange: '取消改签',
      addPassenger: '新增乘客',
      editPassenger: '编辑乘客',
      savePassenger: '保存乘客',
      deletePassenger: '删除乘客',
      selectTrain: '选择车次',
      viewTimetable: '查看时刻表',
      goPay: '立即支付',
      reorder: '再次预订',
      buyReturn: '购买返程',
      contactService: '联系客服',
      invoice: '报销凭证',
      invoiceDetail: '发票详情',
      amountDetail: '订单金额明细',
      continueOrder: '继续下单',
      continueChange: '继续改签',
      selectHotel: '去选酒店',
      refresh: '刷新',
    },
    detail: {
      loading: '正在加载车次详情...',
      selectSeatType: '选择座位类型',
      convenientBuy: '便捷购票',
      noLogin12306: '无需登录12306',
      perPerson: '/人',
      proService: '专业客服',
      service247Short: '7*24服务',
      bookingNoticeTitle: '预订须知:',
      bookingNoticeBody: '• 请务必仔细核对乘车人信息，确保身份证件在有效期内\n• 开车前请预留充足时间到达车站，建议提前30分钟到达\n• 如遇列车晚点、停运等情况，请关注车站公告或铁路官方信息',
      refundRulesTitle: '退改签规则:',
      refundRulesSummary: '根据中国铁路最新规定，退票改签手续费标准如下。退款将在1-3个工作日内到账，请耐心等待。',
      viewRulesLink: '《查看详细规则》',
      checkingLogin: '检查登录状态...',
      stopLink: '经停 >',
      seatSelected: '已选择{seat}',
    },
    orderDetail: {
      statusInit: '订单初始化中',
      statusTicketFailedReorder: '出票失败，可重新预订',
      statusPartialRefunding: '部分车票正在退票中',
      statusPartialRefunded: '部分车票已退票成功',
      statusRefunding: '正在为您办理退票',
      statusRefunded: '已退票完成',
      statusPartialRefundFailed: '部分车票退票失败',
      confirmCancelMsg: '是否取消订单',
      passengerUnit: '{count}位乘客',
      changeStatusInit: '初始状态',
      changeStatusPayPending: '待支付',
      changeStatusTicketing: '出票中',
      changeStatusTicketSuccess: '出票成功',
      changeStatusTicketFailed: '出票失败',
      changeStatusCancelled: '订单取消',
      changeStatusPartialRefunding: '部分退票中',
      changeStatusPartialRefunded: '部分退票成功',
      changeStatusRefunding: '退票中',
      changeStatusRefunded: '已退票',
      changeStatusChanged: '已改签',
      changeStatusChanging: '改签中',
      changeStatusChangeCancelled: '取消改签',
      changeStatusChangeFailed: '改签失败',
      changeStatusPartialRefundFailed: '部分退票失败',
      changeStatusRefundFailed: '退票失败',
      childTicketRulesTitle: '儿童票价格收取规则',
      childAgeUnder6: '年龄小于6岁：',
      childAgeUnder6Desc: '免费，无座',
      childAge6to14: '年龄6-14岁：',
      childAge6to14Desc: '半价，有座',
      childAge14Plus: '年龄≥14岁：',
      childAge14PlusDesc: '全价，有座',
      childTicketRefundNotice: '儿童票均按成人票价收取，出票成功后退还差价',
      seatPreferenceNotice: '此为您创建订单时的选座偏好，实际出票座位可能有所不同',
      invoiceListTitle: '火车票发票列表',
      invoiceAmount: '金额：￥{amount}',
      ticketCountFormat: '{count}张{seatType}',
      selectSeatsLabel: '选择座位：{seats}',
      sleeperSeatSelect: '卧铺选座',
      seatPreference: '座位偏好',
      businessSeatSelect: '商务座选座',
      firstClassSeatSelect: '一等座选座',
      secondClassSeatSelect: '二等座选座',
      highSpeedSeatSelect: '高铁动车选座',
    },
    orderFill: {
      changePassenger: '改签乘客',
      passengerInfo: '乘客信息',
      selectedSummary: '已选择{count}人（成人{adult}人{childPart}）',
      childPart: '，儿童{count}人',
      selectedSeats: '已选座位：{seats}',
      seatLegend: '座位图例',
      seatAvailable: '可选',
      seatSelectedLabel: '已选',
      windowLabel: '窗',
      aisleLabel: '过道',
      upperBerth: '上铺',
      middleBerth: '中铺',
      lowerBerth: '下铺',
      upperBerthDesc: '价格较低，空间较小',
      middleBerthDesc: '适中价格，便于上下',
      lowerBerthDesc: '价格较高，方便舒适',
      berthSelectedSummary: '已选择 {selected} 个铺位 / 共需 {total} 个',
      windowSeat: '靠窗',
      aisleSeat: '靠过道',
      windowSeatDesc: '景色好，安静',
      aisleSeatDesc: '方便活动',
      preferenceSelectedSummary: '已选择 {selected} 个位置 / 共需 {total} 个',
      selectedSeatsHeader: '已选座位 ({selected}/{total})',
      selectedBerthHeader: '已选铺位 ({selected}/{total})',
      selectedPreferenceHeader: '已选座位偏好 ({selected}/{total})',
      berthMultiply: '{type} × {count}',
      bookingOptions: '购票选项',
      changeOptions: '改签选项',
      acceptNoSeatDesc: '如该坐席售完，是否购买无座票',
      acceptNoSeatDescChange: '如该坐席售完，是否接受无座票',
      orderDetail: '订单明细',
      changeFeeDetail: '改签费用明细',
      ticketInfo: '车票信息',
      changeTicketLabel: '改签车票',
      originalTicketAdult: '原车票（成人票）',
      estimatedRefund: '预计退回金额',
      needPayAmount: '需支付金额',
      ticketSubtotal: '车票小计',
      serviceFeeRow: '服务费',
      couponDiscountRow: '优惠券',
      totalRow: '合计',
      submitChange: '提交改签',
      submitOrder: '提交订单',
      seatNumberSuffix: '号',
      deletePassengerMsg: '确定要删除乘客"{name}"吗？',
      smsVerifyTitle: '请发送短信验证',
      smsVerifyMsg: '为保障您的账户安全，请完成短信验证后继续操作',
      nonRefundableTitle: '不可退款提示',
      nonRefundableMsg: '该票不可退款，是否继续{action}？',
      gotIt: '知道了',
      totalPayAmount: '共需支付',
      estimatedRefundNote: '（改签成功后退还差价，请耐心等待退款，预计7个工作日内到账）',
      reminderChild: '儿童票均按成人票价收取，出票成功后退还差价；',
      reminderStandby: '用户提交候补订单时需预付票款，预付款按照该候补订单中最高票价计算（卧铺按下铺票价计算）。兑现成功，预付款大于实际票款的，自动退还差价。',
      couponLoading: '获取优惠券中...',
      noCouponUse: '不使用优惠券',
      couponValidUntil: '有效期至：{date}',
      couponDefaultLabel: '优惠券',
      couponPercentOff: '{price}折优惠',
      couponDiscountUnit: '折',
      agreementReadConfirm: '已阅读并同意',
      serviceConfirmTitle: '特别说明',
      serviceConfirmBody: '本次订单包含服务费 {amount} 元。该费用用于确保您购票成功，一旦出票，后续若办理退票或改签，服务费将无法退还，请您知悉。',
      thinkAgain: '再考虑下',
      agreeAndPay: '同意并继续支付',
      agreement: {
        publishDates: '发布时间：2023年12月22日\n生效时间：2023年12月29日',
        personalInfoBody: '尊敬的用户，感谢您使用旅团团的【火车票代购】业务，具体的服务将由最终的服务提供方（请参见订单信息确认页列示的名称）向您提供。您理解，旅团团需将订单信息确认页中涉及的您勾选的产品信息与您输入或勾选的个人信息传输至该服务提供方系统，以供其核实您的身份、确认您的订单，并最终为您提供服务。\n\n在提供有关信息前，旅团团将严格执行《中华人民共和国个人信息保护法》以及旅团团《个人信息保护政策》的规定，要求有关服务提供方切实履行个人信息保护义务，仅就提供服务之目的处理您的个人信息，不得擅自转移、共享、提供、出售或基于其他目的处理您的个人信息。\n\n请您再次审慎核实确认您勾选的产品信息与您输入或勾选的个人信息。若您点击【立即预订/免密支付/普通抢票/低速抢票/快速抢票/高速抢票/极速抢票/神速抢票/去支付】，表示您同意旅团团基于为您提供服务之目的，向有关服务提供方提供您的个人信息；如果订单信息中包含未成年人信息的，则本人作为订单中未成年人的监护人（或已征得该未成年人监护人的同意），有权使用该未成年人信息提交订单，同意平台为提供产品或服务的目的，处理未成年的个人信息。',
        purchaseNoticeBody: '一、电子客票须知\n1. 电子客票也称"无纸化"车票，是指旅客购买车票后的电子购票凭证。对于此类客票，铁路局不再出具纸质票，旅客可凭购票证件进站。\n2. 使用以下证件购票后，可以凭购票使用的乘车人有效证件通过自助闸机进出站：①二代身份证 ②外国人永久居留证 ③港澳台居民居住证 ④电子护照 ⑤港澳台通行证\n\n二、抢票须知\n1. 支付抢票订单后，会立即开始为您抢票。抢票时间可能较长，发车前1-3天放票概率高，请您耐心等待。\n2. 选择好备选车次和备选座席后，暂收车次和座席的最高价，出票成功后退还差价。\n\n三、购票取票须知\n1. 全国铁路已实施电子客票，无需取纸质车票，普速列车和高铁动车都可以直接刷二代身份证进出站。\n2. 若您遇到未开通电子客票的车站，发车前请携带购票时使用的有效证件原件，在车站人工窗口或车站自助取票机取票。\n\n四、儿童票须知\n1. 儿童票价格收取规则：年龄小于6岁，免费，无座；年龄6-14岁，半价，有座；年龄≥14岁，全价，有座。\n2. 儿童票均按成人票价收取，出票成功后退还差价。\n\n五、退改须知\n铁路局退票手续费：\n1）开车前8天(含)以上：免费退票\n2）开车前48小时以上：收取票价5%的退票费\n3）开车前24-48小时：收取票价10%的退票费\n4）开车前不足24小时：收取票价20%的退票费\n5）开车前2小时后线上停止退票\n\n说明：\n1）退票手续费由铁路局收取；\n2）手续费不足2元按照2元收取；\n3）距离开车7天及以内的车票，改签至8天及以上后退票收取5%的手续费；\n4）下单成功手续费不予返还；\n5）平台额外增加17元退票手续费(每人，不包含12306购票方式)；\n6）退票约7个工作日内到账。',
        serviceBody: '旅团团平台内火车票服务由旅团团（广东）技术有限公司（"旅团团"）运营，并由第三方服务商提供信息服务。《火车票服务协议》（以下简称"本协议"）是旅团团（广东）技术有限公司及其服务商（以下统称"我司"或"我们"）与用户就平台上提供的火车票服务所订立的合约。\n\n一、服务描述\n您使用我司提供的火车票服务向铁路官方网站或授权代售点进行查询、购票、退票、改签、候补等服务，为实现前述服务，您授权我司代您注册12306账户和代您申请人证核验等认证服务。\n\n二、个人信息授权\n您理解，旅团团需将您在订票中勾选的产品信息与您输入或勾选的个人信息传输至我司为您提供服务。在提供有关信息前，旅团团将严格执行《中华人民共和国个人信息保护法》以及旅团团《个人信息保护政策》的规定。\n\n三、免责申明\n1. 您完全同意及认可，本服务将铁路客运机构的服务信息汇集供用户查阅，火车票的查询、购票、退票、改签、候补需由铁路客运机构执行，我司无法对出票成功率作100%承诺。\n2. 因不可抗力或铁路客运机构的原因导致您未能如订单内容接受服务，我司不承担责任。\n3. 如因您未能遵守法律法规和铁路客运机构的规定，您需自行承担全部法律责任。\n\n四、争议解决\n您对本服务相关事宜的履行发生争议，您同意按照中华人民共和国颁布的相关法律法规解决争议，并同意接受广州市天河区人民法院的管辖。',
      },
    },
    rules: {
      popupTitle: '退票/改签说明',
      refundFeeTitle: '退票手续费标准',
      changeTitle: '改签规则',
      specialTitle: '特殊情况',
      tipTitle: '温馨提示',
    },
    popup: {
      amountDetail: '订单金额明细',
      applyRefund: '申请退票',
      refundHistory: '退订记录',
      invoiceDetail: '发票详情',
      filterTitle: '筛选条件',
      cardTypeTitle: '请选择证件类型',
      stopStations: '经停站信息',
      refundChangeRules: '退票/改签说明',
      selectCoupon: '选择优惠券',
      confirmDelete: '确认删除',
      contactService: '联系客服',
      tip: '提示',
      nonRefundable: '不可退款提示',
      agreementPersonalInfo: '个人信息授权声明',
      agreementPurchaseNotice: '购票须知',
      agreementService: '火车票信息服务协议',
    },
  },
}
